import React from "react";
import { Col, Row } from "antd";
import { AnimationOnScroll } from "react-animation-on-scroll";

import ContentSection from "./ContentSection";

import EllipseLeft from "../../../../../assets/images/Ellipse-1.svg";
import EllipseRight from "../../../../../assets/images/Ellipse-2.svg";
import DotsRight from "../../../../../assets/images/dots.svg";
import LaptopImg from "../../../../../assets/images/laptop-img-dashboard.png";
const About: React.FC = () => {
  return (
    <section id="About">
      <div className="container">
        <img src={EllipseLeft} alt="Background Circle media" title="Background Circle Image" className="EllipseLeft" />
        <Row gutter={50} align={"middle"}>
          <Col
            xs={24}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
          >
            <AnimationOnScroll
              animateOnce
              animateIn="animate__bounceInLeft"
              offset={100}
            >
              <img src={LaptopImg} alt="Courier and Logistic Management Software" title="Optimize courier and logistics operations with advanced software" className="LaptopImg" />
            </AnimationOnScroll>
          </Col>
          <Col
            xs={24}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
          >
            <ContentSection />
          </Col>
        </Row>
      </div>
      <img src={EllipseRight} alt="Background Circle" title="Background Circle" className="EllipseRight" />
      <img src={DotsRight} alt="Background Dot media" title="Background Dot Image" className="DotsRight" />
    </section>
  );
};
export default About;
